import { StatusBadge } from "@/components/wheel/StatusBadge";
import { useCockpitAdmin } from "@/cockpit/CockpitPanel";

export function CockpitShell({
  title,
  blurb,
  ticker,
  onTicker,
  tickers = [],
  badge,
  lastRun,
  children,
  testid,
  extraFilters,
}) {
  const isAdmin = useCockpitAdmin();
  const names = tickers.length ? tickers : [];
  return (
    <div className="p-4 md:p-6 max-w-[1400px] mx-auto space-y-3" data-testid={testid}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h1 className="text-lg font-bold" style={{ fontFamily: "Chivo, sans-serif" }}>{title}</h1>
          <p className="text-[11px] mt-1 max-w-3xl" style={{ color: "var(--hoip-text-tertiary)" }}>
            {isAdmin ? blurb : "Data may be delayed."}
          </p>
          {isAdmin && lastRun?.finished_at ? (
            <p className="text-[10px] mt-1 font-mono-data" style={{ color: "var(--hoip-text-tertiary)" }}>
              Last house-feed cache {String(lastRun.finished_at).slice(0, 16).replace("T", " ")} UTC
            </p>
          ) : null}
        </div>
        {isAdmin ? badge : null}
      </div>
      {extraFilters}
      {names.length > 0 ? (
        <div className="flex items-center gap-1.5 flex-wrap" data-testid="cockpit-ticker-chips">
          {names.slice(0, 40).map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => onTicker(t)}
              className="text-[11px] px-2 py-0.5 rounded-sm border font-mono-data"
              style={{
                color: ticker === t ? "var(--hoip-bg)" : "var(--hoip-text-secondary)",
                background: ticker === t ? "var(--hoip-text-primary)" : "var(--hoip-card)",
                borderColor: ticker === t ? "var(--hoip-text-primary)" : "var(--hoip-border)",
              }}
            >
              {t}
            </button>
          ))}
        </div>
      ) : null}
      {children}
      {isAdmin ? (
        <p className="text-[10px]" style={{ color: "var(--hoip-text-tertiary)" }}>
          Informational only. Not investment advice. Filings can be delayed, amended, or incomplete.
          13F is a lagged holdings snapshot, not a buy/sell tape. Form 144 is proposed, not confirmed sold.
        </p>
      ) : null}
    </div>
  );
}

export function HouseFeedBadge() {
  return (
    <StatusBadge
      tier="info"
      text="House feed · FDN Mongo"
      title="Cached FinancialData.net snapshot from Mongo. Delayed house feed — not live broker data and not SentiSense."
      testid="cockpit-house-feed-badge"
    />
  );
}
